import { fetchBanners } from "@/apis/lendingRequests"
import { bannersAtom } from "@/atoms/bannersState"
import { Seo } from "@/components/base"
import { Home } from "@/components/home-new"
import { IS_MAINNET, LOCALE_EN, LOCALE_VI } from "@/utils/constants"
import { sendEventLog } from "@/utils/tracking-events"
import { useSetAtom } from "jotai"
import { useRouter } from "next/router"
import { useEffect } from "react"
import { useQuery } from "react-query"
import Layout from "@/components/layout"
import useTrans from "@/hooks/useTrans"

export default function HomePage() {
  const trans = useTrans()
  const router = useRouter()
  const locale = router.locale === LOCALE_VI ? LOCALE_VI : LOCALE_EN

  const { data: bannerData, refetch: refetchListBanners } = useQuery(["fetchBanners"], () => fetchBanners(locale), {
    staleTime: 10000,
  })

  const setBanners = useSetAtom(bannersAtom)

  useEffect(() => {
    sendEventLog("view_relend_landing_page", {
      isMainnet: IS_MAINNET,
    })
  }, [])

  useEffect(() => {
    refetchListBanners()
  }, [refetchListBanners, locale])

  useEffect(() => {
    if (!bannerData && bannerData?.error) {
      setBanners([])
    } else {
      setBanners(bannerData)
    }
  }, [bannerData, setBanners])

  return (
    <>
      <Seo
        data={{
          title: `${trans.seo.seo_title}`,
          description: trans.seo.seo_description,
        }}
      />
      <Layout>
        <Home />
      </Layout>
    </>
  )
}
